export const buildLocationNavigateToUrl = (latitude: number, longitude: number) => {
    const { userAgent, maxTouchPoints } = navigator;
    const hasTouch = ('ontouchstart' in window) ||
        (maxTouchPoints > 0);
    const isSmallScreen = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;

    // Combine feature detection (touch) with screen size (matchMedia) and userAgent for broader mobile detection.
    const isMobileDevice = hasTouch ||
        isSmallScreen ||
        /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    if (isMobileDevice) {
        if (isAndroid) {
            return `geo:${latitude},${longitude}`;
        }

        if (isIOS) {
            // TODO: IOS doesnt support single universal link offer installed nav app. consider having multiple links like google maps, apple's and waze.
            // const wazeUniversalLink = `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes`;
            // const appleUniversalLink = `http://maps.apple.com/?daddr=${latitude},${longitude}&dirflg=d`
        }
    }

    return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=driving`
}